module.exports = __webpack_public_path__ + "static/media/apple.ee41df97.svg";